import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {Resource} from 'app/constants/resource';
import {LastCallIn, ILastCallIn} from 'app/blocks/model/last-call-in.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {LastCallInService} from 'app/blocks/service/api/last-call-in.service';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class LastCallInResource extends AbstractEntityResource<ILastCallIn> {
    constructor(lastCallInService: LastCallInService, router: Router) {
        super(
            Resource.LAST_CALL_IN,
            lastCallInService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.LAST_CALL_IN, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.LAST_CALL_IN),
            (entity?) => new LastCallIn(entity),
            (entity) => entity
        );
    }
}
